<template>
  <component
    :is="disabled ? 'div' : 'router-link'"
    :to="!disabled ? to : undefined"
  >
    <div
      class="w-56 h-56 rounded-2xl flex flex-col items-center justify-center text-center p-4 shadow-lg transition duration-200 transform"
      :class="[
        disabled
          ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
          : 'bg-white hover:scale-105 hover:bg-blue-100 cursor-pointer text-gray-800'
      ]"
    >
      <component
        :is="iconComponent"
        class="w-12 h-12 mb-4"
        :class="disabled ? 'text-[#94ac7c]' : 'text-[#3c9ca4]'"
      />
      <div class="text-xl font-semibold">
        {{ title }}
      </div>
    </div>
  </component>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import {
  BarChart,
  HelpCircle,
  Cube,
  Users,
  ClipboardList,
  LayoutDashboard,
} from 'lucide-vue-next';

const props = defineProps({
  title: String,
  to: String,
  icon: String,
  disabled: {
    type: Boolean,
    default: false,
  }
});

const iconComponent = computed(() => {
  switch (props.icon) {
    case 'bar-chart':
      return BarChart;
    case 'question-mark-circle':
      return HelpCircle;
    case 'clipboard-list':
      return ClipboardList;
    case 'layout-dashboard':
      return LayoutDashboard;
    case 'users':
      return Users;
    case 'cube':
    default:
      return Cube;
  }
});
</script>
